<template>
  <div class="topDiv" style>
    <el-row style="height: 100%">
      <el-col style="height: 100%" class="leftMenus" :span="4">
        <CompayMenus :menuIndex="menuIndex" />
      </el-col>

      <el-col :span="20" class="setPadding">
        <el-row class="whiteBox"></el-row>
        <div class="mainContent">
          <el-row class="setPageWidth" style="margin-top: -80px">
            <el-col
              :span="4"
              class="positionFont"
            
            >
              <!-- @click.native="returnSearchPage" -->
              <span class="iconfont">&#xe609;</span>
              <span>搜索应聘者</span>
            </el-col>
            <el-col :span="20" class="setPageWidth">
              <RightMenus />
            </el-col>
          </el-row>

          <div
            class="setPageWidth formContent"
            style="height: 90vh; overflow-y: auto; margin-top: 20px"
          >
            <el-scrollbar style="height: 100%">
              <el-row style="margin-top: 5px; margin-left: -38px">
                <el-col>
                  <PcSearchCriteria :searchparams="searchparams" />
                </el-col>
              </el-row>

              <el-row
                v-if="this.$store.state.users.searchPeopleList"
                style="margin-top: 10px"
              >
                <el-col
                  :span="12"
                  v-for="(item, index) in this.$store.state.users
                    .searchPeopleList"
                  :key="index"
                  class="paddingStyle"
                >
                  <Candidates :searchpeople="item" />
                </el-col>
              </el-row>

              <el-row
                v-if="!this.$store.state.users.searchPeopleList"
                class="noData"
              >
                <el-col class>
                  <el-col style="margin-top: 180px">
                    <img
                      class="viewNoDataPng"
                      src="@/assets/pcImage/noData.png"
                      alt
                    />
                  </el-col>

                  <el-col class="noDataFont">暂无数据</el-col>
                </el-col>
              </el-row>
            </el-scrollbar>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import RightMenus from "@/components/company/RightMenus.vue";
import CompayMenus from "@/components/company/CompayMenus.vue";
import Candidates from "@/components/company/Candidates.vue";
import PcPeopleSreach from "@/components/company/PcPeopleSreach.vue";
import PcSearchCriteria from "@/components/company/PcSearchCriteria.vue";

export default {
  name: "",

  components: {
    RightMenus,
    CompayMenus,
    Candidates,
    PcPeopleSreach,
    PcSearchCriteria,
  },
  props: {},
  data() {
    return {
      menuIndex: 3,
      sreachValue: null,
      buttonSelect: 1,
      searchparams: this.$route.params.searchWord,
    };
  },
  
  methods: {
    returnSearchPage() {
      this.$router.push("/pcSreach");
    },
  },
  created() {

    let params = this.$route.params.searchWord;
    if (params) {
      this.searchparams = params;
    }
  },
};
</script>
<style lang="stylus" scoped>
.topDiv {
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  height: 100%;
  // background-color: #F0F2F5;
  margin: 0 auto;

  .setPadding {
    padding: 0 0 0 260px;
    width: 100%;
  }

  .noDataFont {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #b2b2b2;
    line-height: 24px;
  }

  .returnIconStyle {
    width: 20px;
    height: 20px;
    transform: rotate(-90deg);
    margin-right: 5px;
    margin-bottom: -2px;
  }

  .noData {
    margin-top: 10px;
    background-color: #fff;
    height: 650px;
    margin: 20px auto;
    text-align: center;
    vertical-align: middle;
  }

  .paddingStyle {
    padding: 10px 24px 0px 0;
  }

  .noDataButton {
    margin-top: 40px;
    width: 88px;
    height: 32px;
    background: #f82b18;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 32px;
    text-align: center;
    border-radius: 4px;
  }

  .viewNoDataPng {
    width: 264px;
    height: 162px;
  }

  .buttonStyle, .buttonStyleNo {
    width: 88px;
    height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 32px;
    text-align: center;
    border-radius: 4px;
    margin-right: 15px;
  }

  .buttonStyle {
    background: #f82b18;
    color: rgba(255, 255, 255, 1);
  }

  .buttonStyleNo {
    background: #fff;
    color: rgba(0, 0, 0, 1);
  }

  .formContent {
    background-color: #F0F2F5;
    margin-top: 20px;
    min-height: 500px;
    min-width: 860px;
  }

  .whiteBox {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    background: #fff;
    height: 64px;
  }

  .positionFont {
    height: 64px;
    line-height: 64px;
    color: #000;
  }

  .leftMenus {
    position: fixed;
    width: 256px;
    height: 100%;
    top: 0;
    z-index: 100;
    box-shadow: 1px 0 5px rgba(0, 0, 0, 0.05);
    background: #252830;
  }

  .setPageWidth {
    max-width: 1180px;
    margin: 0 auto;

    .marginTopButton {
      margin: 10px 0 11px 0;
    }
  }

  .mainContent {
    padding: 15px 40px 15px 40px;
    height: 100%;
    position: relative;
    font-size: 18px;
    line-height: 64px;
    text-align: left;
    background-color: #F0F2F5;
  }
}
</style>